import React from 'react';
import { Redirect, RouteChildrenProps } from 'react-router';
import { ConsumerRoutes } from 'src/shared/Routes';
import { resolveShortLink } from './ShortLinks';

export const ShortLinkRedirect: React.FC<RouteChildrenProps> = ({ location }) => (
  <Redirect to={{ ...location, pathname: resolveShortLink(location.pathname) ?? ConsumerRoutes.CONSUMER_LANDING }} />
);
